import { DescriptionOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import { IFilePreviewProps } from 'src/features/patient_asset';

const FilePreview: React.FC<IFilePreviewProps> = ({ file, type }) => {
	if (type === 'image') {
		return (
			<img
				src={URL.createObjectURL(file)}
				alt='preview'
				style={{
					border: 1,
					borderStyle: 'dashed',
					marginBottom: 'auto',
					marginTop: 'auto',
					width: '100%',
					height: '100%',
					objectFit: 'cover',
					borderRadius: '4px',
					pointerEvents: 'none',
					userSelect: 'none',
				}}
			/>
		);
	}

	if (type === 'file') {
		return (
			<Box
				sx={{
					border: 1,
					borderStyle: 'dashed',
					width: '100%',
					height: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<DescriptionOutlined sx={{ width: 100, height: 100 }} />
				<Typography
					sx={{
						width: '100%',
						fontSize: { xs: '14px', sm: '18px' },
						lineHeight: '31.5px',
						textAlign: 'center',
						wordWrap: 'break-word',
					}}
				>
					{file.name}
				</Typography>
			</Box>
		);
	}

	return null;
};

export default FilePreview;
